import styled from 'styled-components';

const AppContainer = styled.div`
  background: #333;
  min-height: 100vh;
`;

const Banner = styled.div`
  background: #607D8B;
  color: white;
  padding: 10px 0;
  text-align: center;
  font-size: 2em;
  margin-bottom: 50px;
`;

const AppButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #607D8B;
  color: white;
  border-radius: 50px;
  padding: 15px 30px;
  font-size: 1.5em;
  text-decoration: none;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23);
  margin: 10px auto;
  transition: transform .2s;
  
  &:hover {
    transform: scale(1.1);
  }
`;

const ButtonLogo = styled.img`
  height: 80px;
  margin-bottom: 10px;
  border-radius: 50%;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: calc(50vh - 100px);
  padding-top: 20px;
`;

const DonateButton = styled(AppButton)`
  background: yellow;
  color: #607D8B;
  margin-top: 100px;
`;

const LandingPage = () => {
  return (
    <AppContainer>
      <Banner>Choose an App</Banner>
      <ButtonContainer>
        <AppButton href="https://edwardern.github.io/decision">
          <ButtonLogo src="https://th.bing.com/th/id/OIG.slVpTZHHIrTmveNT2T08?pid=ImgGn" />
          OPR Decision Tree
        </AppButton>
        <AppButton href="https://edwardern.github.io/mission">
          <ButtonLogo src="https://th.bing.com/th/id/OIG.Yr1gj8jNu9jx6bXxKCtC?pid=ImgGn" />
          OPR GF Mission Cards
        </AppButton>
        <AppButton href="https://edwardern.github.io/missiondeck">
          <ButtonLogo src="https://th.bing.com/th/id/OIG.g3hA.OiUzX8j2TDAGsTs?pid=ImgGn" />
          40k Mission Deck
        </AppButton>
        <DonateButton href="https://www.paypal.com/donate/?business=ZTZGDKWHQTR72&no_recurring=0&item_name=Thank+you+for+deciding+to+support+me.+I+assure+you%2C+this+money+doesn%27t+go+to+anything+non-essential.&currency_code=CAD">Donate</DonateButton>
      </ButtonContainer>
    </AppContainer>
  );
}

export default LandingPage;